<template>
  <v-form ref="form" v-model="valid" lazy-validation class="full">
    <v-col class="md-hidden pager-row">
      <span class="back-button" @click="goBack">
        <i class="fas fa-chevron-left m-r-5"></i>
        Go Back
      </span>
      <radial-progress-bar
        :diameter="45"
        :completed-steps="completedSteps"
        :total-steps="totalSteps"
        :startColor="'#00A8C8'"
        :stopColor="'#00A8C8'"
        :innerStrokeColor="'#B0E5EF'"
        :strokeWidth="3"
        :innerStrokeWidth="3"
        class="right progress-bar"
      >
        <p>
          <span>{{ completedSteps }}</span> of {{ totalSteps }}
        </p>
      </radial-progress-bar>
    </v-col>
    <div class="form-body col-md-8 col col-12">
      <v-col cols="12" sm="12" md="12" class="header-div">
        <h3>Type of Yacht</h3>
      </v-col>

      <v-row class="form-item-section">
        <v-col cols="12" sm="12" md="12" class="input-wrapper">
          <v-list-item-title class="m-b-15">
            Select one: <span class="red-star">*</span>
          </v-list-item-title>
          <v-radio-group
            :row="!isMobile"
            :rules="[rules.required]"
            v-model="yatchDetails.yacht_hull_type"
          >
            <v-radio value="MNH">
              <template v-slot:label>
                <span class="m-l-5">Monohull</span>
              </template>
            </v-radio>
            <v-radio value="MTH">
              <template v-slot:label>
                <span class="m-l-5">Multihull</span>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
        <v-col cols="12" sm="12" md="12" class="input-wrapper">
          <v-list-item-title class="m-b-15">
            Select one: <span class="red-star">*</span>
          </v-list-item-title>
          <v-radio-group
            :row="!isMobile"
            :rules="[rules.required]"
            v-model="yatchDetails.yacht_power_type"
          >
            <v-radio value="MY">
              <template v-slot:label>
                <span class="m-l-5">Motor Yacht</span>
              </template>
            </v-radio>
            <v-radio value="SY">
              <template v-slot:label>
                <span class="m-l-5">Sailing Yacht</span>
              </template>
            </v-radio>
          </v-radio-group>
        </v-col>
      </v-row>

      <v-col cols="12" sm="12" md="12" class="header-div">
        <h3>Yacht Details</h3>
      </v-col>

      <v-row class="form-item-section">
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Name of yacht (if any)
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.name"
            color="primary"
            solo
            outlined
            flat
            dense
            maxlength="20"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Year built <span class="red-star">*</span>
          </v-list-item-title>
          <v-select
            v-model="yatchDetails.year_built"
            outlined
            dense
            color="primary"
            :items="yearsArray"
            label="Select"
            item-text="value"
            item-value="value"
            :single-line="true"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Licensing office / port of registry
            <span class="red-star">*</span>
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.licensing_office"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="[rules.required]"
            :validate-on-blur="true"
            maxlength="30"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Licence/registration No. / IMO No.
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.license_no"
            color="primary"
            solo
            outlined
            flat
            dense
            maxlength="30"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Builders <span class="red-star">*</span>
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.builders"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="[rules.required]"
            :validate-on-blur="true"
            maxlength="30"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Model <span class="red-star">*</span>
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.model"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="[rules.required]"
            :validate-on-blur="true"
            maxlength="30"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Material of hull <span class="red-star">*</span>
          </v-list-item-title>
          <v-select
            v-model="yatchDetails.material_hull"
            @change="changeOtherBox($event, 'material_hull_other')"
            outlined
            dense
            color="primary"
            :items="hullMaterialArray"
            label="Select"
            item-text="value"
            item-value="key"
            :single-line="true"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          class="input-wrapper"
          v-bind:class="{ hide: yatchDetails.material_hull !== 'OTH' }"
        >
          <v-list-item-title>
            Other <span class="red-star">*</span>
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.material_hull_other"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="
              yatchDetails.material_hull === 'OTH' ? [rules.required] : []
            "
            maxlength="50"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          class="input-wrapper"
          v-if="yatchDetails.yacht_power_type === 'SY'"
        >
          <v-list-item-title>
            Material of mast, rigging and sails <span class="red-star">*</span>
          </v-list-item-title>
          <v-select
            v-model="yatchDetails.material_mast"
            @change="changeOtherBox($event, 'material_mast_other')"
            outlined
            dense
            color="primary"
            :items="mystMaterialArray"
            label="Select"
            item-text="value"
            item-value="key"
            :single-line="true"
            :rules="yatchDetails.yacht_power_type === 'SY' ? [rules.required] : []"
          />
        </v-col>
        <v-col
          cols="12"
          sm="12"
          md="6"
          class="input-wrapper"
          v-bind:class="{ hide: yatchDetails.material_mast !== 'OTH' }"
          v-if="yatchDetails.yacht_power_type === 'SY'"
        >
          <v-list-item-title>
            Other <span class="red-star">*</span>
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.material_mast_other"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="
              yatchDetails.material_mast === 'OTH' ? [rules.required] : []
            "
            maxlength="50"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Length (m) <span class="red-star">*</span>
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.length"
            @keypress="isDecimalNumber($event)"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="[rules.lengthValidation, rules.required, rules.negativeValidation]"
            :validate-on-blur="true"
            maxlength="6"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Beam (m)
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.beam"
            @keypress="isDecimalNumber($event)"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="[rules.beamValidation, rules.negativeValidation]"
            :validate-on-blur="true"
            maxlength="5"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Gross Tonnage (tons)
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.gross_tonnage"
            color="primary"
            solo
            outlined
            flat
            dense
            @keypress="isNumber($event)"
            :rules="[rules.numberRule, rules.negativeValidation]"
            @focus="removeComma('gross_tonnage')"
            @blur="formatPrice('gross_tonnage')"
            :validate-on-blur="true"
            maxLength="4"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper"> </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Make of engine(s) <span class="red-star">*</span>
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.make_engine"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="[rules.required]"
            :validate-on-blur="true"
            maxLength="20"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Engine serial number(s) <span class="red-star">*</span>
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.engine_serialno"
            color="primary"
            solo
            outlined
            flat
            dense
            :rules="[rules.required]"
            :validate-on-blur="true"
            maxLength="80"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Engine Power of each (h.p.) <span class="red-star">*</span>
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.horse_power"
            color="primary"
            solo
            outlined
            flat
            dense
            @keypress="isNumber($event)"
            :rules="[rules.numberRule, rules.required, rules.negativeValidation]"
            @focus="removeComma('horse_power')"
            @blur="formatPrice('horse_power')"
            :validate-on-blur="true"
            maxLength="5"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Maximum designed speed (knots)
          </v-list-item-title>
          <v-text-field
            v-model="yatchDetails.max_speed"
            color="primary"
            solo
            outlined
            flat
            dense
            @keypress="isNumber($event)"
            :rules="[rules.numberRule, rules.negativeValidation]"
            maxLength="2"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Type of engine <span class="red-star">*</span>
          </v-list-item-title>
          <v-select
            v-model="yatchDetails.engine_type"
            outlined
            dense
            color="primary"
            :items="engineType"
            label="Select"
            item-text="value"
            item-value="key"
            :single-line="true"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Number of engines <span class="red-star">*</span>
          </v-list-item-title>
          <v-select
            v-model="yatchDetails.engine_number"
            outlined
            dense
            color="primary"
            :items="engineNumber"
            label="Select"
            item-text="value"
            item-value="key"
            :single-line="true"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Type of fuel used <span class="red-star">*</span>
          </v-list-item-title>
          <v-select
            v-model="yatchDetails.fuel_type"
            outlined
            dense
            color="primary"
            :items="fuelType"
            label="Select"
            item-text="value"
            item-value="key"
            :single-line="true"
            :rules="[rules.required]"
          />
        </v-col>
        <v-col cols="12" sm="12" md="6" class="input-wrapper">
          <v-list-item-title>
            Surface drive <span class="red-star">*</span>
          </v-list-item-title>
          <v-select
            v-model="yatchDetails.surface_drive"
            outlined
            dense
            color="primary"
            :items="surfaceDrive"
            label="Select"
            item-text="value"
            item-value="key"
            :single-line="true"
            :rules="[rules.required]"
          />
        </v-col>
      </v-row>
    </div>

    <v-col
      cols="12"
      class="button-container col-md-8"
      v-if="!$store.state.isEditMode"
    >
      <v-btn
        class="ma-2 form-button cancel"
        outlined
        color="black"
        @click="goBack"
      >
        <span class="back-icon"></span>
        Previous Step
      </v-btn>
      <v-btn
        class="ma-2 form-button continue right"
        dark
        color="#00A8C8"
        @click="validateAndGoNext"
      >
        Continue
        <span class="next-icon"></span>
      </v-btn>
    </v-col>
    <v-col
      cols="12"
      class="button-container col-md-8"
      v-if="$store.state.isEditMode"
    >
      <v-btn
        class="ma-2 form-button cancel"
        outlined
        color="black"
        @click="cancelChange"
      >
        <span class="back-icon"></span>
        Cancel Changes
      </v-btn>
      <v-btn
        class="ma-2 form-button continue right"
        dark
        color="#00A8C8"
        @click="applyChange"
      >
        Apply Changes
        <span class="next-icon"></span>
      </v-btn>
    </v-col>
  </v-form>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import RadialProgressBar from "vue-radial-progress";
import PremiumApi from "@/plugins/axios";

export default {
  components: {
    RadialProgressBar,
  },
  data() {
    return {
      valid: false,
      completedSteps: 2,
      totalSteps: 7,
      yatchDetails: this.getYatchDetails(),
      isMobile: false,
      rules: {
        required: (value) => !!value || "This field is mandatory",
        numberRule: (value) => {
          const pattern = /^\d+$/;
          if (value == null || value == undefined) {
            return true;
          }
          return (
            pattern.test(
              String(value)
                .replace(/\,/g, "")
                .replace(/\-/g, "")
            ) || "This field must have numeric value"
          );
        },
        lengthValidation: (value) => {
          const pattern = /^(\d*\.?\d{1,2})$/;
          if ((value == null || value == undefined) || value == '') {
            return true;
          }
          const isNumeric = pattern.test(
            String(value)
              .replace(/\,/g, "")
              .replace(/\-/g, "")
          );
          if (isNumeric) {
            return parseFloat(value) > 999.99 ? "Maximum value 999.99" : true;
          } else {
            return "This field must have numeric value with maximum 2 decimal places";
          }
        },
        beamValidation: (value) => {
          const pattern = /^(\d*\.?\d{1,2})$/;
          if ((value == null || value == undefined) || value == '') {
            return true;
          }
          const isNumeric = pattern.test(
            String(value)
              .replace(/\,/g, "")
              .replace(/\-/g, "")
          );
          if (isNumeric) {
            return parseFloat(value) > 99.99 ? "Maximum value 99.99" : true;
          } else {
            return "This field must have numeric value with maximum 2 decimal places";
          }
        },
        negativeValidation: (value) => {
          if ((value == null || value == undefined) || value == '') {
            return true;
          }
          return parseFloat(value) > 0 || "Value should me more than 0";
        },
        emailValidation: (value) => {
          var pattern = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;
          if (value == null || value === undefined || value === "") {
            return true;
          }
          return pattern.test(value) || "E-mail must be valid";
        },
      },
    };
  },
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isDecimalNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    validateAndGoNext: function() {
      this.yatchChanged();
      if (this.$refs.form.validate()) {
        this.$store.commit("saveYatchDetails", this.yatchDetails);
        this.$store.state.formPageNumber = 3;
      } else {
        let context = this;
        setTimeout(function() {
          let inavlidField = context.$el.querySelector(".v-messages__message");
          if (inavlidField) {
            context.$vuetify.goTo(
              context.$el.querySelector(".v-messages__message").parentNode
                .parentNode.parentNode.parentNode.parentNode.parentNode,
              { container: document.documentElement, duration: 100 }
            );
            let focusElement = context.$el.querySelector(".v-messages__message")
              .parentNode.parentNode.parentNode.parentNode.parentNode
              .parentNode;
            focusElement.focus();
          }
        }, 100);
      }
    },
    goBack: function() {
      this.$store.state.formPageNumber = 1;
    },
    cancelChange: function() {
      this.$store.state.isEditMode = false;
      this.$store.state.formPageNumber = 7;
    },
    applyChange: function() {
      this.yatchChanged();
      if (this.$refs.form.validate()) {
        let pageNumber = 7;
        let editModeFlag = false;
        const oldFormValue = this.getYatchDetails();
        if (
          this.yatchDetails.yacht_power_type !== oldFormValue.yacht_power_type
        ) {
          const policyDetails = this.getPolicyDetails();
          policyDetails.is_cover_sails = "N";
          policyDetails.cover_sails_replacement_value = null;
          policyDetails.is_cover_sports = "N";
          policyDetails.cover_sports_type = null;
          policyDetails.limit_liability = null;
          pageNumber = 5;
          editModeFlag = true;
          this.$store.commit("savePolicyDetails", policyDetails);
        }
        if (this.yatchDetails.length !== oldFormValue.length) {
          const oldFlag = parseFloat(oldFormValue.length) >= 23;
          const newFlag = parseFloat(this.yatchDetails.length) >= 23;
          if (oldFlag !== newFlag) {
            if (newFlag) {
              pageNumber = 5;
              editModeFlag = true;
            } else {
              editModeFlag = false;
              pageNumber = 7;
            }
            const policyDetails = this.getPolicyDetails();
            policyDetails.is_additional_cover_required = "N";
            this.$store.commit("savePolicyDetails", policyDetails);
          }
        }
        this.$store.commit("saveYatchDetails", this.yatchDetails);
        this.$store.state.isEditMode = editModeFlag;
        this.$store.state.formPageNumber = pageNumber;
      } else {
        let context = this;
        setTimeout(function() {
          let inavlidField = context.$el.querySelector(".v-messages__message");
          if (inavlidField) {
            context.$vuetify.goTo(
              context.$el.querySelector(".v-messages__message").parentNode
                .parentNode.parentNode.parentNode.parentNode.parentNode,
              { container: document.documentElement, duration: 100 }
            );
            let focusElement = context.$el.querySelector(".v-messages__message")
              .parentNode.parentNode.parentNode.parentNode.parentNode
              .parentNode;
            focusElement.focus();
          }
        }, 100);
      }
    },
    getYatchDetails: function() {
      return _.cloneDeep(this.$store.getters.getYatchDetails);
    },
    getPolicyDetails: function() {
      return _.cloneDeep(this.$store.getters.getPolicyDetails);
    },
    changeOtherBox: function(e, key) {
      if (e !== "OTH") {
        this.yatchDetails[key] = null;
      }
    },
    onResize() {
      this.isMobile = window.innerWidth < 720;
    },
    yatchChanged: function() {
      if (this.yatchDetails.yacht_power_type !== "SY") {
        this.yatchDetails.material_mast = null;
        this.yatchDetails.material_mast_other = null;
      }
    },
    trackPage: function() {
      const postData = this.$store.state.accessData;
      postData.url = window.location.href + "/YatchDetail";
      PremiumApi.logAccess(postData, function(data) {
        console.log("Data sent with : " + JSON.stringify(postData));
      });
    },
    removeComma(key) {
      this.yatchDetails[key] = !this.yatchDetails[key]
        ? null
        : this.yatchDetails[key].replace(/,/g, "");
    },
    formatPrice(key) {
      this.yatchDetails[key] = !this.yatchDetails[key]
        ? null
        : parseFloat(this.yatchDetails[key]).toLocaleString();
    },
  },
  mounted: function() {
    window.scrollTo(0, 0);
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
    this.trackPage();
  },
  beforeDestroy() {
    if (typeof window === "undefined") return;
    window.removeEventListener("resize", this.onResize, { passive: true });
  },
  computed: {
    ...mapGetters([
      "hullMaterialArray",
      "mystMaterialArray",
      "engineType",
      "engineNumber",
      "fuelType",
      "surfaceDrive",
    ]),
    yearsArray() {
      const year = new Date().getFullYear();
      return Array.from(
        { length: year - 1949 },
        (value, index) => year - index
      );
    },
  },
};
</script>
